import { FC, useContext, useEffect, useMemo, useState } from 'react';
import { AccuWeatherNearByThingsToDoProps, forecastType } from '../AccuWeather.types';
import { PageParamsContext } from '../../../modules/context/PageContext';
import { weatherIcons } from '../../../modules/utils/constants/constants';
// import { useAccuWeatherData } from '../context/AccuWeatherDataContext';
import { accuWeatherStore, useAccuWeatherStore } from '../../../modules/store/accuWeatherStore';
import { AccuWeatherMockUXL } from '../__mock__/AccuWeatherMock';

export const AccuWeatherNearByThingsToDo: FC<AccuWeatherNearByThingsToDoProps> = ({
  weatherForecast,
  daysOfWeek,
  accuWeatherImage,
  imageAltText,
  isAuthorMode,
}) => {
  const { preProcessorResponse } = useContext(PageParamsContext);
  const { cna = false, sameTab = false } = preProcessorResponse || {};
  // const { accuWeatherData } = useAccuWeatherData();
  const accuWeatherData = useAccuWeatherStore((state: accuWeatherStore) => state.accuWeatherData);
  const data = useMemo(() => {
    return isAuthorMode ? { ...AccuWeatherMockUXL } : accuWeatherData ? { ...accuWeatherData } : null;
  }, [accuWeatherData, isAuthorMode]);
  const [forecast, setForecast] = useState<Array<forecastType>>([]);

  useEffect(() => {
    if (data && Object.keys(data) && Object.keys(data)?.length && data?.property?.weather?.tenDay) {
      const forecast: Array<forecastType> = [];
      const presentDate = new Date().getTime();
      const weatherDate = new Date(data?.property?.weather?.tenDay[0].date).getTime();
      // Verify if the current date on the system matches the date on the UXL weather data at index 0
      // Difference between present date and UXL weather date at index 0
      const dateDiff = Math.ceil((presentDate - weatherDate) / (1000 * 3600 * 24));

      data?.property?.weather?.tenDay?.forEach?.(
        (
          item: {
            date: string | number | Date;
            day: { weatherIcon: number };
            temperature: { maximum: { value: number; unit: string } };
            mobileLink: string;
            link: string;
          },
          index: number
        ) => {
          // Display data for the next five days, including today
          if (index >= dateDiff && index < dateDiff + 5) {
            forecast.push({
              date: new Date(item?.date),
              weatherIcon: item?.day?.weatherIcon,
              temperature: {
                value: Math.trunc(item?.temperature?.maximum?.value),
                unit: item?.temperature?.maximum?.unit,
              },
              mobileLink: item?.mobileLink,
              link: item?.link,
            });
          }
        }
      );

      setForecast([...forecast]);
    }
  }, [data]);

  return (forecast as Array<forecastType>).length > 0 ? (
    <div className="d-flex">
      <div className="container">
        <div className="accu-weather-forecast__container d-flex justify-content-center">
          <div className="accu-weather-forecast__container__content">
            <span className="t-font-xs" data-testid="near-by-accu-weather">
              {weatherForecast}
            </span>
          </div>
          <div className="d-flex">
            {(forecast as Array<forecastType>)?.map((weather, index) => {
              return (
                <a
                  href={`${weather.link}&partner=web_marriott_adc`}
                  target={sameTab || cna ? '_self' : '_blank'}
                  className="accu-weather-forecast__container__wrapper"
                  rel="noreferrer"
                  key={`forecast-day-${index}`}
                  data-testid={`forecast-day-link-${index}`}
                >
                  <div className="d-flex accu-weather__container__wrapper-cell">
                    <div className="d-flex forecast-day-cell">
                      <span className="forecast-day-cell-day t-font-xs" data-testid={`forecast-day-${index}`}>
                        {daysOfWeek[new Date(weather.date).getDay() > 0 ? new Date(weather.date).getDay() - 1 : 6]}
                      </span>
                    </div>
                    <div className="icon-cell">
                      {weatherIcons?.map((icon, i) => {
                        if (weather?.weatherIcon === icon.iconKey) {
                          return (
                            <span
                              className={icon.iconClass}
                              data-testid={`forecast-day-${index}-icon-${i}`}
                              key={`forecast-day-${index}-icon-${i}`}
                            ></span>
                          );
                        }
                        return <span></span>;
                      })}
                    </div>
                    <div>
                      <span className="forecast-temperature-cell t-font-m">{weather?.temperature?.value}</span>
                      <span className="forecast-unit-cell">°{weather?.temperature?.unit}</span>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
          <div className="accu-weather-forecast__container__logo pl-2 pl-xl-3 d-flex">
            <a
              href={`${data?.property?.weather?.tenDay[0]?.link}&partner=web_marriott_adc`}
              target={sameTab || cna ? '_self' : '_blank'}
              rel="noreferrer"
              className="d-flex align-items-center"
            >
              <span>
                <img src={accuWeatherImage} alt={imageAltText} className="accu-weather__container__logo_img"></img>
              </span>
              <span className="icon-forward-arrow t-accent-color"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
